module.exports = __webpack_public_path__ + "img/cart-delete-bg.f042825c.png";